import $ from 'jquery';
import { createConflictMap, setConflictLayerFilter } from 'map';

function updateConflictLayer(vdMapPromise) {
    const from = $('input[name="amendBean.startDate"]').val();
    const to = $('input[name="amendBean.endDate"]').val();
    setConflictLayerFilter(from, to, vdMapPromise);
}

$(() => {
    const vdMapPromise = createConflictMap('amendMap');

    $('input[name="amendBean.startDate"], input[name="amendBean.endDate"]').on('change', () => {
        updateConflictLayer(vdMapPromise);
    });

    updateConflictLayer(vdMapPromise);
});
